import generate from '../../utils/contentSagasGenerator'
import { CONTENT_LOAD, CONTENT_LOAD_SUCCESS, CONTENT_LOAD_ERROR, PLAYER_SK_GAMES_VALUES_ADDRESS } from './constants'

export default generate(CONTENT_LOAD, CONTENT_LOAD_SUCCESS, CONTENT_LOAD_ERROR, PLAYER_SK_GAMES_VALUES_ADDRESS)
